import { theme } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../../common/Block';
import { ISegmentFilter } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { State as CampaignState } from 'entities/lifecycle/lifeCycle';

interface OwnProps {
  segmentId: string;
  segmentFilter: ISegmentFilter;
  index: number;
  campaignState: CampaignState;
}

export type Props = OwnProps;

export const AllFilter: FC<Props> = props => {
  const { t } = useTranslation();

  return (
    <div>
      <Block
        icon="envelope"
        iconColor={theme.vars.newColor.blue2}
        title={t('campaigns:offsiteEditor.segments.filters.all.name', {
          emailNumber: props.index + 1,
        })}
        value={t('campaigns:offsiteEditor.segments.filters.all.detail')}
        campaignState={props.campaignState}
        valid={true}
        form={<></>}
        disableOpen={true}
      />
    </div>
  );
};
